import { FormInputDropdown } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { selectReasonForMaxFilesSent } from '@AMIEWEB/Order/Store/OrderCreation.selectors';
import { Grid } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SwitchFormComponent } from '../Common/SwitchFormComponent';
import { selectedOrderTypeDetails } from '@AMIEWEB/NewOrder/Store/Order.selectors';

export const OrderTypeSwitchDetails = () => {
  const { t } = useTranslation();
  const { watch, control } = useFormContext();
  const watchMaxFilesSent = watch('maxFilesSent');
  const selectedOrderTypeDetailsItem = useSelector(selectedOrderTypeDetails);
  const reasonForMaxFilesSent = useSelector(selectReasonForMaxFilesSent);

  return (
    <Grid container spacing={4}>
      <Grid item sx={{ marginLeft: '12px' }}>
        <Grid>
          <SwitchFormComponent
            name="ssnRequired"
            label={t('order.newOrderCreation.tabs.orderTypeDetail.ssnRequired')}
            checkedValue={selectedOrderTypeDetailsItem?.ssnRequired}
            onText={t('order.orderDetails.buttonConfirmation.Yes')}
            offText={t('order.orderDetails.buttonConfirmation.No')}
            style={{ paddingRight: '9px' }}
          />
        </Grid>
        <Grid>
          <SwitchFormComponent
            name="dobRequired"
            label={t('order.newOrderCreation.tabs.orderTypeDetail.dobRequired')}
            checkedValue={selectedOrderTypeDetailsItem?.dobRequired}
            onText={t('order.orderDetails.buttonConfirmation.Yes')}
            offText={t('order.orderDetails.buttonConfirmation.No')}
            style={{ paddingRight: '9px' }}
          />
        </Grid>
      </Grid>
      <Grid item sx={{ marginLeft: '24px' }}>
        <Grid>
          <SwitchFormComponent
            name="maxFilesSent"
            label={t('order.newOrderCreation.tabs.orderTypeDetail.maxFilesSent')}
            checkedValue={false}
            onText={t('order.orderDetails.buttonConfirmation.Yes')}
            offText={t('order.orderDetails.buttonConfirmation.No')}
            style={{ paddingRight: '86px' }}
          />
        </Grid>
        {watchMaxFilesSent === true && (
          <Grid sx={{ width: '260px' }}>
            <Controller
              control={control}
              name={'reasonForMaxFilesSent'}
              render={({ field: { onChange, value, ...rest } }) => (
                <FormInputDropdown
                  name={'reasonForMaxFilesSent'}
                  label={t('order.newOrder.reasonForMaxFilesSent')}
                  standard={true}
                  inputValue={value ?? null}
                  options={reasonForMaxFilesSent ?? []}
                  isOrderCreationElement={true}
                  handleChange={e => {
                    onChange(e);
                  }}
                />
              )}
            />
          </Grid>
        )}
        <Grid sx={{ marginTop: watchMaxFilesSent ? '18px' : '0px' }}>
          <SwitchFormComponent
            name="hideFacilityDescription"
            label={t('order.newOrderCreation.tabs.orderTypeDetail.hideFacilityDescription')}
            checkedValue={false}
            tooltip={'Do not post hospital location to external websites'}
            onText={t('order.orderDetails.buttonConfirmation.Yes')}
            offText={t('order.orderDetails.buttonConfirmation.No')}
            style={{ paddingRight: '26px' }}
          />
        </Grid>
        <Grid>
          <SwitchFormComponent          
            name="suppressExternalPosting"
            label={t('order.newOrderCreation.tabs.orderTypeDetail.suppressExternalPosting')}
            checkedValue={false}
            tooltip={'Do not post job to external websites'}
            onText={t('order.orderDetails.buttonConfirmation.Yes')}
            offText={t('order.orderDetails.buttonConfirmation.No')}
            style={{ paddingRight: '12px' }}            
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
